/* eslint semi: 1 */
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

export const SESSION_STORAGE_FILE_UPLOAD_STORE = 'aryaFileUploadStore';
export const PLAYER_SCHEDULES_STATE_KEY = 'playerSchedules';
export const POP_IDS_STATE_KEY = 'popIds';
export const TAG_TYPE_STATE_KEY = {
  RESOURCE_TAGS: 'resourceTags',
  LED_TAGS: 'ledTags',
  VIDEOWALL_TAGS: 'videowallTags',
  PLAYER_TAGS: 'playerTags'
};

export const COMPONENT_KEY = {
  FILES_SCREEN: 'filesScreen',
  LED_SCREEN: 'ledScreen',
  VIDEOWALL_SCREEN: 'videowallScreen',
  PLAYERS_SCREEN: 'playersScreen'
};

/**
 * This will format the item before saving it into the store. The item should have a UID for UI reference.
 * @param {Object} item
 * @returns Object
 */
export const formatStateItem = (item) => {
  if (!_.isPlainObject(item)) {
    return;
  }

  if (_.isEmpty(item.uid)) {
    item.uid = uuidv4();
  }

  return item;
};

/**
 * This will add the item to the list if it doesn't exist, and remove it if it does.
 * @param {Array} items
 * @param {Array} list
 * @returns Array
 */
export const toggleItemsInListIfExist = (items, list) => {
  if (!_.isArray(items) || !_.isArray(list)) {
    return list;
  }

  const res = _.cloneDeep(list);

  for (const item of items) {
    const existingItemIndex = _.findIndex(res, { uid: item.uid });

    if (existingItemIndex === -1) {
      res.push(item);
    } else {
      res.splice(existingItemIndex, 1);
    }
  }

  return res;
};
